import React from 'react';
import SecondaryButton from '../../Component/SecondaryButton';
import './HowToDonate.scss';
import DonateType from '../HomeElements/DonateType';

const HomeDonateSection = props => {
  return (
    <div>
      <div className="row">
        <div className="col-md-offset-2 col-md-8 text-center">
          <h2 className="section-header">Wie kann ich spenden?</h2>
          <p className="section-header-subtitle">
            Für Menschen, die einem Kind einen Weihnachtswunsch erfüllen
            möchten, gibt es drei Möglichkeiten:
          </p>
        </div>
      </div>
      <div className="row equal-height">
        <DonateType
          title={'Direkte Wunscherfüllung'}
          content={
            'Wunsch aussuchen, Geschenk besorgen, einpacken und in der Lutherkirche abgeben.'
          }
          to={'/howto/#direct-wish-fulfillment-section'}
        />
        <DonateType
          title={'Geldspende für einen bestimmten Wunsch'}
          content={
            'Für den Kauf größerer Wünsche, z.B. Fahrräder, brauchen wir auch zahlreiche Geldspenden.'
          }
          to={'/howto/#donation-section'}
        />
        {<DonateType
          title={'Geldspende für die Aktion allgemein'}
          content={[
            'Sie können unter folgender Kontonummer spenden:',
            <br key="nl1" />,
            <strong key="s1">Empfänger: Südstadt-Leben e.V.</strong>,
            <br key="nl2" />,
            <strong key="s2" style={{ whiteSpace: 'nowrap' }}>IBAN: DE43 3506 0190 1013 4760 86</strong>,
            <br key="nl3" />,
            'Verwendungszweck: Weihnachtswunschaktion',
            <p>Bank für Kirche und Diakonie</p>
          ]}
          to={'/howto/#transfer-section'}
        />}
      </div>
      <div className="row">
        <div className="col-md-12 text-center donatebutton">
          <SecondaryButton title="WUNSCHLISTE" to="/list" size="lg" />
        </div>
      </div>
    </div>
  );
};

export default HomeDonateSection;



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/HowToDonate.js